// Navigation du cockpit directeur — portage du handoff Claude Design.
//
// Source : Directeur/Sidebar.jsx (const DIRECTOR_NAV) et Directeur/Header.jsx
// (const PAGE_TITLES). Les identifiants du design (dashboard, overview, …)
// deviennent des routes /directeur/<id>, et les icônes maison `DirIcon` sont
// remplacées par leurs équivalents lucide-react (mêmes tracés, même nommage).
//
// Ce module est la seule source de vérité pour le menu, les intitulés de page
// et les clés de pastilles : le shell, le header et le placeholder le lisent.

import {
  LayoutDashboard,
  Building2,
  Users,
  UserCheck,
  Map,
  CalendarDays,
  GraduationCap,
  AlertTriangle,
  MessageSquare,
  CalendarCheck,
  BarChart3,
  Briefcase,
  FileText,
  ShieldCheck,
  Settings,
} from "lucide-react";

// Sections du design. `badge` = clé renvoyée par GET /directeur/sidebar-counts/.
export const DIRECTEUR_NAV = [
  {
    items: [
      { to: "/directeur", label: "Tableau de bord", icon: LayoutDashboard, end: true },
    ],
  },
  {
    title: "Établissement",
    items: [
      { to: "/directeur/overview", label: "Vue d'ensemble", icon: Building2 },
      { to: "/directeur/students", label: "Élèves", icon: Users },
      { to: "/directeur/staff", label: "Enseignants & personnel", icon: UserCheck },
      { to: "/directeur/rooms", label: "Salles & bâtiments", icon: Map },
    ],
  },
  {
    title: "Opérationnel",
    items: [
      { to: "/directeur/schedule", label: "Emploi du temps", icon: CalendarDays },
      { to: "/directeur/pedagogy", label: "Pédagogie & résultats", icon: GraduationCap },
      { to: "/directeur/attendance", label: "Absences & incidents", icon: AlertTriangle, badge: "attendance" },
      { to: "/directeur/communication", label: "Communication", icon: MessageSquare, badge: "communication" },
    ],
  },
  {
    title: "Administration",
    items: [
      { to: "/directeur/events", label: "Réunions & événements", icon: CalendarCheck },
      { to: "/directeur/budget", label: "Budget & finances", icon: BarChart3 },
      { to: "/directeur/hr", label: "RH & validations", icon: Briefcase, badge: "hr" },
      { to: "/directeur/documents", label: "Documents", icon: FileText },
    ],
  },
  {
    title: "Système",
    items: [
      { to: "/directeur/compliance", label: "Conformité & logs", icon: ShieldCheck },
      { to: "/directeur/settings", label: "Paramètres", icon: Settings },
    ],
  },
];

// Intitulés d'en-tête, repris tels quels du design (Header.jsx · PAGE_TITLES).
// Le sous-titre du tableau de bord porte la date du jour (le design l'avait figée).
export const DIRECTEUR_PAGE_TITLES = {
  "/directeur": { title: "Tableau de bord", sub: "Vue opérationnelle" },
  "/directeur/overview": { title: "Vue d'ensemble", sub: "Bilan institutionnel" },
  "/directeur/students": { title: "Élèves", sub: "Supervision de la population scolaire" },
  "/directeur/staff": { title: "Enseignants & personnel", sub: "Ressources humaines et encadrement" },
  "/directeur/rooms": { title: "Salles & bâtiments", sub: "Référentiel des locaux · source de l'emploi du temps" },
  "/directeur/schedule": { title: "Emploi du temps", sub: "Continuité pédagogique et remplacements" },
  "/directeur/schedule/generateur": {
    title: "Générateur d'emploi du temps",
    sub: "Assistant de génération — solveur sous contraintes",
  },
  "/directeur/pedagogy": { title: "Pédagogie & résultats", sub: "Performance académique par classe et niveau" },
  "/directeur/pedagogy/bulletins": { title: "Cycle de bulletins", sub: "Saisie, conseil de classe et publication aux familles" },
  "/directeur/attendance": { title: "Absences & incidents", sub: "Suivi de la vie scolaire et signalements" },
  "/directeur/communication": { title: "Communication", sub: "Messages, annonces et correspondance" },
  "/directeur/events": { title: "Réunions & événements", sub: "Calendrier institutionnel" },
  "/directeur/budget": { title: "Budget & finances", sub: "Gestion financière de l'établissement" },
  "/directeur/hr": { title: "RH & validations", sub: "Personnel, congés et approbations en attente" },
  "/directeur/documents": { title: "Documents", sub: "GED et archives administratives" },
  "/directeur/compliance": { title: "Conformité & logs", sub: "Sécurité, droits et traçabilité" },
  "/directeur/settings": { title: "Paramètres", sub: "Configuration de l'établissement" },
};

// Liste à plat — utilisée par la recherche rapide du header.
export const DIRECTEUR_NAV_FLAT = DIRECTEUR_NAV.flatMap((s) => s.items);
